module.exports = __webpack_public_path__ + "img/tcb-logo-horizontal.0287cc9e.png";